/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov
 */
import React, { Component } from 'react'

import './TeamEditor.css'
import TeamRoleSetter from './TeamRoleSetter'
import {webApi} from '../../../lib/WebApi'

import TRCInput from '../../../trace/TRCInput'

export default class TeamEditor extends Component {

    constructor(props) {
        super(props)
        this.onTeamTitleChanged = this.onTeamTitleChanged.bind(this)
        this.onTeamAbbrChanged = this.onTeamAbbrChanged.bind(this)
        this.onTeamYearChanged = this.onTeamYearChanged.bind(this)
        this.onRegeneratePassphrase = this.onRegeneratePassphrase.bind(this)
        this.onGenderChanged = this.onGenderChanged.bind(this)
        const team = this.props.team ? this.props.team : {}
        this.state = {
            editState: this.editStateFromTeam(team)
        }
        if(props.onChange) {
            props.onChange(this.state.editState)
        }
    }

    editStateFromTeam(team) {
        return {
            title: team.title,
            abbr: team.abbr,
            access_password: team.access_password,
            players_gender: team.players_gender ? team.players_gender : '',
            players_birth_year: team.players_birth_year ? team.players_birth_year : ''
        }
    }

    setEditState(prop, field) {
        const editState = Object.assign({}, this.state.editState, prop)
        this.setState({editState: editState})
        if(this.props.onChange) {
            this.props.onChange(editState, field)
        }
    }

    // eslint-disable-next-line react/no-deprecated
    componentWillReceiveProps(nextProps) {
        const team = nextProps.team ? nextProps.team : {}
        if(!this.props.team && nextProps.team) {
            this.setEditState(this.editStateFromTeam(team))
        }
    }

    caption(field, text) {
        const errors = this.props.errors ? this.props.errors : []
        for(const error of errors) {
            if (error.field === field) {
                return error.error
            }
        }
        return text
    }

    errorClass(field) {
        const errors = this.props.errors ? this.props.errors : []
        for(const error of errors) {
            if (error.field === field) {
                return 'invalid'
            }
        }
        return ''
    }

    componentDidMount() {
        if(!this.state.editState.access_password) {
            webApi.getRandomPassphrase().then((password) => {
                if(!this.state.editState.access_password) {
                    //this.setState({ editState: { access_password: password } })
                    this.setEditState({access_password: password})
                }
            })
        }
    }

    render() {
        const editState = this.state.editState
        return (
            <div className="TeamEditor">
                <div className="area">
                    <h4>Title</h4>
                    <div>
                        <TRCInput
                            type="text"
                            className={`team-title ${this.errorClass('title')}`}
                            placeholder="Enter Team Title/Name"
                            name="title"
                            value={editState.title}
                            onChange={this.onTeamTitleChanged} />
                    </div>
                    <span className="error">
                        {this.caption('title', '')}
                    </span>
                </div>
                <div className="area">
                    <h4>Abbreviation</h4>
                    <div>
                        <TRCInput
                            type="text"
                            className={`team-abbr ${this.errorClass('abbr')}`}
                            placeholder="Enter a short Abrv (3-6 letters max)"
                            name="abbr"
                            value={editState.abbr}
                            onChange={this.onTeamAbbrChanged} />
                    </div>
                    <span className="error">
                        {this.caption('abbr', '')}
                    </span>
                </div>
                {/*
                <div className="area">
                    <h4 className="mini-title">Passphrase</h4>
                    <span className="multiline-text">Your team&apos;s passphrase can be used by anyone to upload new games or edit your team&apos;s roster. Passphrases are generated automatically.</span>
                </div>
                <div className="passphrase-area">
                    <span className="passphrase">{editState.access_password}</span>
                    <TRCButton
                        ghost
                        onClick={this.onRegeneratePassphrase}>
                        <i className="trace-icon refresh-green" />
                        <span>Regenerate</span>
                    </TRCButton>
                </div>
                */}
                <div className="area">
                    <h4>Gender</h4>
                    <TRCInput
                        type="select"
                        className={`gender-selector ${this.errorClass('players_gender')}`} 
                        onChange={this.onGenderChanged}
                        options={[
                            {title: '---', value: 'Unset'}, 
                            {title: 'Female', value: 'female'}, 
                            {title: 'Male', value: 'male'}, 
                        ]}
                        value={editState.players_gender}
                    />
                    <span className="error">
                        {this.caption('players_gender', '')}
                    </span>
                </div>
                <div className="area">
                    <h4>Birth year</h4>
                    <div>
                        <TRCInput
                            type="text"
                            className={`team-birth ${this.errorClass('players_birth_year')}`}
                            placeholder="Year"
                            name="year"
                            value={editState.players_birth_year}
                            onChange={this.onTeamYearChanged} />
                    </div>
                    <span className="error">
                        {this.caption('players_birth_year', '')}
                    </span>
                </div>
                <TeamRoleSetter
                    entries={this.props.members}
                    title="Members"
                    onRoleChanged={this.props.onMemberRoleChanged}
                />
            </div>
        )
    }

    onTeamTitleChanged(val) {
        this.setEditState({title: val}, 'title')
    }

    onTeamAbbrChanged(val) {
        this.setEditState({abbr: val}, 'abbr')
    }

    onTeamYearChanged(val) {
        this.setEditState({players_birth_year: val}, 'players_birth_year')
    }

    onGenderChanged(val) {
        this.setEditState({players_gender: val}, 'players_gender')
    }

    onRegeneratePassphrase(e) {
        e.preventDefault()
        webApi.getRandomPassphrase().then((password) => {this.setEditState({access_password: password})})
    }
}
